module.exports = __webpack_public_path__ + "img/cimg04.e7b3f74e.png";